<template><div><h1>VUX V2.6.5 released</h1>
<h2><a href="/en/components/cell-box.html">CellBox</a></h2>
<ul><li>[feature] add prop:align-items</li>
</ul>
<h2><a href="/en/components/checklist.html">Checklist</a></h2>
<ul><li>[fix] fix missing icon style when using checklist along #2041</li>
<li>[fix] initializing the tempValue when created #2059</li>
</ul>
<h2><a href="/en/components/confirm.html">Confirm</a></h2>
<ul><li>[enhance] fix click events trigger twice when clicking fast #2048</li>
</ul>
<h2><a href="/en/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[feature] add event:on-hde event:on-show #2053</li>
</ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul><li>[enhance] fix validating logic for is-type:china-mobile with mask #2040</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.6.5 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.6.5-137.vue?db4d2a84